/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFFindingResolutionItem
 */
export interface CRSFFindingResolutionItem {
    /**
     * 
     * @type {string}
     * @memberof CRSFFindingResolutionItem
     */
    action: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFFindingResolutionItem
     */
    ts: number;
}

/**
 * Check if a given object implements the CRSFFindingResolutionItem interface.
 */
export function instanceOfCRSFFindingResolutionItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "action" in value;
    isInstance = isInstance && "ts" in value;

    return isInstance;
}

export function CRSFFindingResolutionItemFromJSON(json: any): CRSFFindingResolutionItem {
    return CRSFFindingResolutionItemFromJSONTyped(json, false);
}

export function CRSFFindingResolutionItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFFindingResolutionItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'action': json['action'],
        'ts': json['ts'],
    };
}

export function CRSFFindingResolutionItemToJSON(value?: CRSFFindingResolutionItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'action': value.action,
        'ts': value.ts,
    };
}

